export const LOCAL_COMPANY = 'open-epower-company-id';
export const LOCAL_COMPANY_TYPE = 'open-epower-company-type';
export const LOCAL_COMPANY_EVENT = 'open-epower-company-event';
export const MENU_TYPE_VALUE = 1;
export const FUNC_TYPE_VALUE = 2;
export const WINDOW_PERMISSIONS_EVENT = 'user-permissions-event';
export const WINDOW_MENU_PERMISSIONS = 'USER_MENU_PERMISSIONS';
export const WINDOW_FUNC_PERMISSIONS = 'USER_FUNC_PERMISSIONS';
export const ALL_SUPPLIER_ID = '-1';

export const SOURCE = 'open-platform';
